import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import VLANProfilesHelpModal from "./Help";
import VLANProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import vlanComposition from "./composition";


const ConfigVLANProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings
      {...vlanComposition}
      {...composedAPI}
      {...settings}
    />
    <VLANProfilesHelpModal />
    <VLANProfileSettingsHelpModal />
  </>
);

export default ConfigVLANProfiles;
